<template>
   <div class="scence">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">姓名:</span>
          <div class="selcountry">
          <el-input
            placeholder="请输入姓名"
            v-model="query.searchName"
            @keyup.enter.native="onLoadData"
            class="filter-item"
            style="width: 150px;"
            clearable
            @change="Global.emptyQuery(query.searchName,onLoadData)"
          ></el-input>
          </div>
          <span class="xzqh">角色:</span>
          <div class="selcountry">
            <el-select v-model="query.roleId" filterable clearable placeholder="请选择" @change="onLoadData">
              <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <span class="xzqh">状态:</span>
          <div class="selcountry">
          <el-select
            filterable
            clearable
            placeholder="请选择状态"
            v-model="query.validStatus"
            @change="onLoadData"
            class="filter-item"
            style="width: 110px;"
            >
            <el-option label="启用" :value="'valid'"></el-option>
            <el-option label="禁用" :value="'invalid'"></el-option>
          </el-select>
          </div>
          <span class="search" @click="onLoadData">查询</span>
          <span v-if="allowsPerm.insert" class="add" @click="onAdd" ><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
    <el-table :data="users" v-loading="loading" :max-height="height" border fit highlight-current-row style="width: 100%">
      <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
      <el-table-column align="center" label="用户名" prop="userName"></el-table-column>
      <el-table-column align="center" label="姓名" prop="displayName"></el-table-column>
      <el-table-column align="center" label="电话" prop="phoneNumber"></el-table-column>
      <el-table-column align="center" label="角色" >
          <template slot-scope="scope">
          {{ scope.row.userRoles.length > 0 ? scope.row.userRoles[0].roleName: ''}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdDate" min-width="50" align="center">
         <template slot-scope="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="validStatus" width="70">
        <template slot-scope="{row}">
          {{ row.validStatus === 'Valid' ? '启用' : '禁用' }}
        </template>
      </el-table-column>
      <el-table-column align="center" min-width="90" label="操作">
        <template slot-scope="scope" >
          <div class="operation">
            <span v-if="allowsPerm.delete" class="del" @click="onDelete(scope.row)"><span class="del-icon"></span>删除</span>
            <span v-if="allowsPerm.update" class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
            <span v-if="allowsPerm.delete && isOrdinaryUser(scope.row)" class="reset" @click="onReset(scope.row)"><span class="reset-icon"></span>重置</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    </div>
      </div>
    </div>
    <!-- <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog">
      <el-form ref="userForm" :rules="rules" :model="currentUser" label-width="100px" inline width="40%">
        <div class="dialog_wrapper">
          <el-form-item label="用户名:" required>
            <el-form-item prop="userName">
              <el-input v-model="currentUser.userName" :readonly="currentUser.id > 0" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="姓名:" required>
            <el-form-item prop="displayName">
              <el-input v-model="currentUser.displayName" autocomplete="off"></el-input>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="dialog_wrapper">
          <el-form-item label="初始密码:" required>
            <el-form-item prop="password">
              <el-input type="password" :disabled="edit" v-model="currentUser.password" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="性别:" required>
            <el-form-item prop="gender">
              <el-select v-model="currentUser.gender" placeholder="请选择">
                <el-option
                  v-for="item in genders"
                  :key="item.value"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="dialog_wrapper">
          <el-form-item label="所在地区:" required>
            <el-form-item prop="adcdCode">
              <el-select v-model="currentUser.adcdCode" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in adcds"
                  :key="item.adcd"
                  :label="item.adnm"
                  :value="item.adcd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item label="角色:">
            <el-form-item>
              <el-select v-model="currentUser.Roles" filterable clearable placeholder="请选择">
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="dialog_half">
          <el-col :span="4" class="form-label" style="margin-left: 15px">状态:</el-col>
           <el-col :span="5">
            <el-form-item>
              <el-radio-group v-model="currentUser.validStatus">
                <el-radio label="Valid">启用</el-radio>
                <el-radio label="Invalid">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog> -->
  <!-- 编辑 -->
     <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="abow_dialog">
      <el-form ref="userForm" :rules="rules" :model="currentUser" label-width="100px" inline width="40%">
        <el-form-item label="用户名:" prop="userName">
          <el-input v-model="currentUser.userName" :readonly="currentUser.id > 0" autocomplete="new-userName">
          </el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="displayName">
          <el-input v-model="currentUser.displayName" autocomplete="new-displayName"></el-input>
        </el-form-item>
        <el-form-item label="初始密码:" prop="password" v-if="isShowPassword">
          <el-input type="password" v-bind:disabled="false" v-model="currentUser.password" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="gender">
          <el-select v-model="currentUser.gender" placeholder="请选择">
            <el-option
              v-for="item in genders"
              :key="item.value"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地区:" prop="adcdCode">
          <el-select v-model="currentUser.adcdCode" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in adcds"
              :key="item.adcd"
              :label="item.adnm"
              :value="item.adcd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:" prop="Roles">
          <el-select v-model="currentUser.Roles" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-radio-group v-model="currentUser.validStatus">
            <el-radio label="Valid">启用</el-radio>
            <el-radio label="Invalid">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话:" prop="phoneNumber">
          <el-input v-model="currentUser.phoneNumber"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import accountTypes from '@/store/types/account'
import baseTypes from '@/store/types/base'
import userTypes from '@/store/types/user'
// import userService from '@/api/user'
export default {
  data () {
    return {
      isShowPassword: true,
      loading: false,
      diagShow: false,
      diagTitle: '新增用户',
      defaultPwd: '12345678a',
      height: 10,
      adminId: [],
      query: {
        searchName: '',
        validStatus: '',
        pageIndex: 1,
        pageSize: 2000
      },
      parentAdcdCode: '330621000000000',
      zPageIndex: '1',
      zPageSize: '2000',
      rPageIndex: '1',
      rPageSize: '100',
      genders: ['男', '女'],
      adcds: [],
      currentUser: { 'password': undefined },
      users: [],
      roles: [],
      rules: {
        userName: [
          { required: true, message: '用户名不能为空' },
          { min: 4, message: '不能小于4个字符' }
        ],
        password: [
          { validator: this.Global.checkPassword },
          { required: true, min: 8, message: '长度不能小于8位' },
          { required: true, max: 18, message: '长度不大于18位' }
        ],
        displayName: [
          { required: true, message: '姓名不能为空' }
        ],
        Roles: [
          { required: true, message: '角色不能为空', trigger: 'change' }
        ]
      },
      edit: false
    }
  },
  methods: {
    loadRoles () {
      this.$store.dispatch(accountTypes.GET_ROLES, {
        pageIndex: this.rPageIndex,
        pageSize: this.rPageSize
      }).then(roles => {
        this.roles = roles.results
        this.adminId = []
        this.roles.forEach(item => {
          if (item.groupName === '超级管理员' || item.groupName === '管理员') {
            this.adminId.push(item.id)
          }
        })
      })
    },
    adcddata () {
      this.$store.dispatch(baseTypes.GET_BASEUSERADCD, {
        IsTown: false,
        IsCounty: true,
        parentAdcdCode: this.parentAdcdCode,
        pageIndex: this.zPageIndex,
        pageSize: this.zPageSize
      }).then(data => {
        this.adcds = data.results
      })
    },
    onLoadData () {
      this.loading = true
      this.$store.dispatch(accountTypes.GET_USERS, this.query).then(data => {
        this.users = data.results
        this.loading = false
      })
    },
    onAdd () {
      this.edit = false
      this.diagTitle = '新增用户'
      this.isShowPassword = true
      this.currentUser = {
        id: 0,
        validStatus: 'Valid',
        password: ''
      }
      this.diagShow = true
      this.Global.clearValidate(this, 'userForm')
    },
    onEdit (row) {
      this.isShowPassword = false
      this.edit = true
      this.$nextTick(() => {
        this.currentUser.password = this.defaultPwd
      })
      this.diagTitle = '编辑用户'
      let user = Object.assign(this.currentUser, row)
      this.currentUser = Object.assign({}, user)
      if (user['userRoles'].length > 0) {
        this.$set(this.currentUser, 'Roles', user['userRoles'][0].roleId)
      }
      this.Global.clearValidate(this, 'userForm')
      this.diagShow = true
    },
    onDelete (row) {
      this.$confirm(`确定要删除用户 '${row.displayName}' 吗?`, '确认').then(() => {
        this.loading = true
        this.$store.dispatch(accountTypes.DELETE_USER, row.id).then(() => {
          this.$notify.success({ title: '成功', message: '删除用户成功.' })
          this.onLoadData()
          this.loading = false
        }).catch(() => { this.loading = false })
      }).catch(() => {})
    },
    onSave () {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let user = Object.assign({}, this.currentUser)
          /* 管理员可修改 其他人员密码 oldPassWord */
          // if (this.currentUser.password !== this.defaultPwd) {
          //   const pwdForm = new FormData()
          //   pwdForm.append('newPassWord', this.currentUser.password)
          //   pwdForm.append('checkPass', this.currentUser.password)
          //   pwdForm.append('Id', this.currentUser.id)
          //   userService.changePwd(pwdForm).then(res => {
          //     this.$notify.success({ title: '密码修改成功', message: '密码修改成功.' })
          //   })
          // }
          this.$store.dispatch(accountTypes.SAVE_USER, user).then(() => {
            this.$notify.success({ title: '成功', message: '保存用户成功.' })
            this.diagShow = false
            this.onLoadData()
            this.loading = false
          })
        }
      })
    },
    onReset (row) {
      let rolesArr = []
      let adminArr = []
      this.$confirm(`确定要将用户 '${row.displayName}' 重置密码吗?`, '确认').then(() => {
        this.adminId.forEach(item => {
          let temp = row.userRoles[0].roleId === item
          rolesArr.push(temp)
        })
        rolesArr.forEach((item, index) => {
          if (rolesArr[index]) { adminArr.push(index) }
        })
        if (adminArr.length > 0) {
          this.$notify.warning({ title: '警告', message: '管理员只能为普通用户重置密码' })
        } else {
          // this.$store.dispatch(userTypes.RESET_PWD, { id: row.id }).catch(() => {})
          // this.$notify.success({ title: '成功', message: '重置密码成功' })
          this.$store.dispatch(userTypes.RESET_PWD, { id: row.id }).then(() => {
            this.$notify.success({ title: '成功', message: '重置密码成功' })
          }).catch(() => {
            this.$notify.error({ title: '失败', message: '重置密码失败' })
          })
        }
      }).catch(() => {})
    },
    isOrdinaryUser (val) {
      if (val.userRoles.length > 0) {
        if (val.userRoles[0].roleName === '管理员' || val.userRoles[0].roleName === '超级管理员') {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.onLoadData()
    this.loadRoles()
    this.adcddata()
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.dialog_wrapper {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-around;
  /deep/ .el-select .el-input__inner {
    padding-right: 15px;
  }
}
.dialog_half {
  width: 100%;
  height: 60px;
  line-height: 38px;
}
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 30px 0 0 0;
  }
  .el-dialog__footer {
    padding: 0 30px 30px 0;
  }
}
.operation {
  width: 300px !important;
}
.el-form-item{
    width: 45%;
    margin-left: 22px;
}
.el-form-item__content{
    height: 40px !important;
}
.scence /deep/ .el-dialog .el-select{
    width: 222px !important;
  }
  .scence /deep/ .el-dialog .el-input{
    width: 222px !important;
  }
  /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 222px;
 }
 /deep/ .el-dialog__body .el-form-item .el-form-item__content {
    width: 238px;
  }
  /deep/ .el-dialog__body .el-form-item .el-form-item__content .el-input {
    width: 75%;
  }
  /deep/ .el-dialog__body .el-form-item .el-form-item__content label {
    margin-left: 5px;
  }
</style>
